import axios from 'axios';

// Detect the backend "dataset cache expired" signal. The v2/v4 report data endpoints return
// HTTP 409 { error: 'cache_expired', cacheExpired: true } when a report's pinned dataset cache
// was reaped by clearCaches.php while the report stayed open. The client uses this to prompt a
// reload instead of showing a generic error. Takes an axios error.
export function isCacheExpiredError(err) {
	return err?.response?.status === 409 && err?.response?.data?.cacheExpired === true;
}

// Poll/pre-flight helper: ask the API which of the given pinned cache tables no longer exist
// (POST /report/cache-status). Used by the report's background poll and the AI chat's send
// pre-flight so an expired cache can prompt a reload without the user first interacting. Returns
// the array of expired table names (empty if all still present). Resolves to [] on any failure so
// callers fail open (never block on the check).
export function fetchExpiredCaches(tables) {
	const list = Array.isArray(tables) ? tables.filter(Boolean) : [];
	if (list.length === 0) return Promise.resolve([]);
	return axios
		.post(window.config.API_URL + 'report/cache-status', { tables: list }, { withCredentials: true })
		.then((res) => (Array.isArray(res.data?.expired) ? res.data.expired : []))
		.catch(() => []);
}
